export const CUBE_ROT = 'cube-rotate';
export const CUBE_RESET = 'cube-reset';
export const ACHIEVEMENT_CHECK = 'achievement-check';
export const ACHIEVEMENT_QUEUE_UPDATE = 'achievement-queue-update';
export const ACHIEVEMENT_REMOVE_QUEUE = 'achievement-remove-queue';